module.exports = __webpack_public_path__ + "img/sha.6cd8ebdb.svg";